<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">content_copy</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Duplicate "{{playlist.name}}"</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <div class="tab-item-container">
      <div class="class-info-container">
        <div class="preview-info">
          <span>Create a copy of a playlist you own.  Copy Only will create a copy of the playlist in your Dashboard.  Copy & Edit will create a copy and launch the Playlist Designer.</span>
        </div>
      </div>
    </div>
    <v-card-actions class="row-space" style="height:56px">
     <v-btn flat class="branded-grey" @click="setDashModal(null)">Close</v-btn>
     <v-spacer></v-spacer>
     <v-btn
      flat
      text
      class="branded-text"
      @click="handleDuplicateAndEditPlaylist">
      Copy & Edit
     </v-btn>
     <v-btn
      flat
      text
      class="branded-background text-white"
      @click="handleDuplicatePlaylist">
      Copy Only
     </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  name: 'DuplicatePlaylist',
  props: [
    'playlist', 
  ],
  computed: {
    ...mapGetters([
      'instructorData',
      'ltiLaunch',
      'nodeApiPrefix',
    ]),
  },
  methods: {
    ...mapActions('instructors', [
      'duplicatePlaylist',
    ]),
    ...mapMutations([
      'setDashModal',
    ]),
    async handleDuplicatePlaylist() {
      this.setDashModal(null);
      await this.duplicatePlaylist(this.playlist.id);
    },
    async handleDuplicateAndEditPlaylist() {
      const lmsLaunch = this.LTIlaunch ? '&lms_launch=true' : '';
      this.setDashModal(null)
      const copiedPlaylistHash = await this.duplicatePlaylist(this.playlist.id);
      window.open(`${this.nodeApiPrefix}/course/${copiedPlaylistHash}?token=${this.instructorData.token}${lmsLaunch}`, '_blank');
    },
  },
};
</script>


